import api from './api';

const userService = {
  async getAll() {
    try {
      const response = await api.get('/users');
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener usuarios'
      };
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener usuario:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al obtener usuario'
      };
    }
  },

  async create(userData) {
    try {
      const response = await api.post('/users', userData);
      return response.data;
    } catch (error) {
      console.error('Error al crear usuario:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al crear usuario'
      };
    }
  },

  async update(id, userData) {
    try {
      const response = await api.put(`/users/${id}`, userData);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar usuario:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al actualizar usuario'
      };
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/users/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar usuario:', error);
      return {
        success: false,
        message: error.response?.data?.message || 'Error al eliminar usuario'
      };
    }
  }
};

export default userService;

